import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/Modules/Core/Components/shadcn/card';



import { useAuth } from '@/Modules/Core/Context/AuthContext';
import { AuthServerLoginButton } from '@/Modules/Login/Components/AuthServerLoginButton';
import Logo from '@/Modules/Core/Components/Brand/Logo';

export default function LoginPage() {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [autoSigning, setAutoSigning] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, isLoading: authLoading } = useAuth();
  const hasRedirected = useRef(false);


  // ✅ React env variable (Vite example)
  const localMode = 'true';

  const redirectTo = searchParams.get('redirectTo') || '/';
  const message = searchParams.get('message');
  const errorParam = searchParams.get('error');
  const loggedOutParam = searchParams.get('logged_out');

  // Redirect if already logged in
  useEffect(() => {
    if (user && !authLoading && !hasRedirected.current) {
      hasRedirected.current = true;
      navigate(redirectTo, { replace: true });
    }
  }, [user, authLoading, redirectTo, navigate]);

  // Handle query messages
  useEffect(() => {
    if (message === 'signup-success') {
      setSuccess(
        'Account created successfully! Please check your email to verify your account.'
      );
    }

    if (loggedOutParam === '1') {
      setSuccess('You have been signed out successfully.');
    }

    if (errorParam) {
      switch (errorParam) {
        case 'verification-failed':
          setError(
            'Email verification failed. Please try signing up again or contact support.'
          );
          break;
        case 'session-expired':
          setError('Your session has expired. Please sign in again.');
          break;
        case 'loading-timeout':
          setError('Authentication timed out. Please try signing in again.');
          break;
        default:
          setError('An authentication error occurred. Please try again.');
      }
    }
  }, [message, errorParam, loggedOutParam]);

  return (
    <div className="min-h-[calc(100vh-64px)] bg-background flex items-center justify-center  transition-colors duration-200">
      <div className="w-full flex flex-col items-center justify-center min-h-[calc(100vh-64px)] gap-8">

        <Card className="w-full max-w-md shadow-lg mx-auto">
          <CardContent className="flex flex-col items-center justify-center gap-6 py-12 px-8 text-center font-sans">
            <Logo className="h-10 w-auto" />
            <h1 className="text-3xl font-semibold font-sans">Welcome Back</h1>
            <p className="text-sm sr-only">Sign in to your account to continue</p>

            <AuthServerLoginButton
              redirectTo={redirectTo}
              loginUrl={process.env.OIDC_ISSUER ? `${process.env.OIDC_ISSUER}/login` : undefined}
              label="Sign in"
              variant="primary"
              className="w-48"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
